import type { FaireProductEntity } from "../../entity_types/product";

export const p_9u9jdhyh5z: FaireProductEntity = {
  token: "p_9u9jdhyh5z",
  type: "product",
  name: "Aloha Love Blue | Greeting Card",
  brandName: "Sunshine + Saltwater",
  imageUrl:
    "https://cdn.faire.com/fastly/72bf234c0bfe3198fb2ee736e6d92d7a3e20e1313896e99c63758e13ea96fc33.jpeg",
  priceDollars: 3.47,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/64b08d68f2b515da39483e68aa5a1a75546911df3156f1edf6f1d8d7ee72d5e8.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
